import { createBrowserHistory } from "history";
import { route } from "./shim/jsbridge";

const tiCoreHistory = createBrowserHistory();

const navigateOutsideReact = path => {
  window.location.assign(path);
};

export { navigateOutsideReact, route };

export default tiCoreHistory;
